/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_BottomsInputs */

const en_val_bottoms = /** @type {(inputs: Val_BottomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bottoms`)
};

const es_val_bottoms = /** @type {(inputs: Val_BottomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partes de abajo`)
};

const fr_val_bottoms = /** @type {(inputs: Val_BottomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bas`)
};

const de_val_bottoms = /** @type {(inputs: Val_BottomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterteile`)
};

const ja_val_bottoms = /** @type {(inputs: Val_BottomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ボトムス`)
};

const zh_val_bottoms = /** @type {(inputs: Val_BottomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下装`)
};

const ar_val_bottoms = /** @type {(inputs: Val_BottomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بناطيل (قطعة سفلية)`)
};

const id_val_bottoms = /** @type {(inputs: Val_BottomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bawahan`)
};

const it_val_bottoms = /** @type {(inputs: Val_BottomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantaloni / Sotto`)
};

const ru_val_bottoms = /** @type {(inputs: Val_BottomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Низ`)
};

const pt_val_bottoms = /** @type {(inputs: Val_BottomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partes de Baixo`)
};

const ko_val_bottoms = /** @type {(inputs: Val_BottomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`하의`)
};

/**
* | output |
* | --- |
* | "Bottoms" |
*
* @param {Val_BottomsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_bottoms = /** @type {((inputs?: Val_BottomsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_BottomsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_bottoms(inputs)
	if (locale === "es") return es_val_bottoms(inputs)
	if (locale === "fr") return fr_val_bottoms(inputs)
	if (locale === "de") return de_val_bottoms(inputs)
	if (locale === "ja") return ja_val_bottoms(inputs)
	if (locale === "zh") return zh_val_bottoms(inputs)
	if (locale === "ar") return ar_val_bottoms(inputs)
	if (locale === "id") return id_val_bottoms(inputs)
	if (locale === "it") return it_val_bottoms(inputs)
	if (locale === "ru") return ru_val_bottoms(inputs)
	if (locale === "pt") return pt_val_bottoms(inputs)
	return ko_val_bottoms(inputs)
});